<ng-container [formGroup]="lengthFormGroup">
    <!-- row -->
    <div class="row">
    
        <!-- item -->
        <div class="col-6">
          <div class="form-group">
            <label for="feet" class="visually-hidden">Feet</label>
            <input id="feet" type="text" class="form-control" formControlName="Feet" placeholder="Feet" maxlength="2" tabindex="0" [ngClass]="{'input-required': isRequired}">
            <error-messages [form]="parent" [field]="formGroupParent + '.Feet'" skipFeedback="true"></error-messages>
          </div>
        </div>
        <!-- /item -->
    
        <!-- item -->
        <div class="col-6">
          <div class="form-group">
            <label for="inches" class="visually-hidden">Inches</label>
            <input id="inches" type="text" class="form-control" formControlName="Inches" placeholder="Inches" maxlength="2" tabindex="0" [ngClass]="{'input-required': isRequired}">
            <error-messages [form]="parent" [field]="formGroupParent + '.Inches'" skipFeedback="true"></error-messages>
          </div>
        </div>
        <!-- /item -->
    
    </div><!-- /row -->
    
    </ng-container>